
export async function postToServer(url, data) {
    var res;

    const options = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };
    res = await fetch(url, options);
    return res;
}

export async function getFromServer(url) {
    var res;

    await fetch(url)
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            res = data;
        });

    return res;
};
